const MISSING_COMPONENT_POINTER_ERROR = 'Can not retrieve component type if a component pointer is not provided';
export const isBuilderComponent = (adapter, compRef) => {
  if (!compRef.id) {
    return false;
  }
  try {
    return adapter.isBuilderComponent(compRef);
  } catch (error) {
    if (error instanceof Error && error.message === MISSING_COMPONENT_POINTER_ERROR) {
      return false;
    }
    throw error;
  }
};
//# sourceMappingURL=is-builder-component.js.map